import { useDispatch } from 'react-redux';
import { mapRowsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import Commons from '../../../../Services/Common/Common';
import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';
import { useSave } from '../../../../Hooks/useSave';
import { TbmActions } from '../../../../Reducer/TbmReducer';

export const SaveMapper = {
  SessionCd: (row) => Commons.EncryptAES(row.sessionCd.toString() ?? ''),
  TbmTitle: (row) => Commons.EncryptAES(row.tbmTitle ?? ''),
  CurStepOrder: (row) => Commons.EncryptAES(row.curStepOrder.toString() ?? '0'),
  CurStepCode: (row) => Commons.EncryptAES(row.curStepCode ?? ''),
  CurPosition: (row) => Commons.EncryptAES(row.curPosition.toString() ?? '0'),
  IsPlaying: (row) => Commons.EncryptAES(row.isPlaying ?? 'N'),
  SessionStatus: (row) => Commons.EncryptAES(row.sessionStatus ?? 'READY'),
  HostId: (_, context) => context.userInfo?.userid ?? '',
  CustCd: (_, context) => Commons.EncryptAES(context.userInfo?.custCd),
  TbmDate: (row) => Commons.EncryptAES(row.tbmDate ?? ''),
  TbmAddress: (row) => Commons.EncryptAES(row.tbmAddress ?? ''),
  TbmContent: (row) => Commons.EncryptAES(row.tbmContent ?? ''),
  VideoPath: (row) => Commons.EncryptAES(row.videoPath ?? ''),
  FilePath: (row) => Commons.EncryptAES(row.filePath ?? ''),
  PlanPath: (row) => Commons.EncryptAES(row.planPath ?? ''),
  MeetPath: (row) => Commons.EncryptAES(row.meetPath ?? ''),
  EntryPath: (row) => Commons.EncryptAES(row.entryPath ?? ''),
  SignPath: (row) => Commons.EncryptAES(row.signPath ?? ''),
  SignDate: (row) => Commons.EncryptAES(row.signDate ?? ''),
  StartDt: (row) => Commons.EncryptAES(row.startDt ?? ''),
  EndDt: (row) => Commons.EncryptAES(row.endDt ?? ''),
  TotalElapsedTime: (row) =>
    Commons.EncryptAES(row.totalElapsedTime.toString() ?? '0'),
  SessionSteps: (row) => row.sessionSteps ?? [],
  UserId: (_, context) => context.userInfo?.userid ?? '',
};

export function useSaveTbmSession(options = {}) {
  return useSaveMutation((rows) => {
    const payload = mapRowsBySchema(rows, SaveMapper);
    return apiRequest(
      'post1',
      Global.urls.ToolBoxMeeting.saveTbmNewU1,
      payload
    );
  }, options);
}

/**
 * TBM 진행자 세션 저장(saveTbmNewU1, M_MASTER_BASIC).
 * 성공 시 sessionData 갱신.
 *
 * @param {object} [options] useSave에 그대로 전달 가능. onSuccess는 기본 동작 뒤에 호출됨.
 * @param {(payload: { saveDetailData: any, requestRows: any, userInfo: any }) => void | Promise<void>} [options.onSuccess]
 */
export function useTbmSessionSave(options = {}) {
  const dispatch = useDispatch();
  const { onSuccess, ...saveOptions } = options;
  const { runAsync: SaveTbmSessionAsync } = useSaveTbmSession();

  const { run: SaveTbmSession } = useSave({
    menuId: 'M_MASTER_BASIC',
    requestSave: (rows) => SaveTbmSessionAsync(rows),
    showSuccess: false,
    onSuccess: async (rows) => {
      const data = rows.saveDetailData[0].data[0];
      dispatch(TbmActions.setSessionData(data));

      await onSuccess?.(rows);
    },
    ...saveOptions,
  });

  return { SaveTbmSession, SaveTbmSessionAsync };
}
